export default "/images/f7e7b4e71d708c432f0bbeb01a6c4294.avif";